

export function BridgerMPEAEL(props, selectedStandard) {

    const { result, data, } = props

    const inputs = data?.repetitivelyPulsed ?? data?.cw ?? data?.singlePulse ?? data?.FO_cw ?? data?.FO_singlePulse ?? data?.FO_repetitivelyPulsed

    const getAE = (AE, unit) => {
        if (AE.includes("J") || AE.includes("W")) {
            return AE
        }
        else if (unit === "W") {
            return AE + "W/m²"
        }
        else if (unit === "J") {
            return AE + "J/m²"
        }
    }
    const MPE = result?.MPE?.mpeStandard?.pretty || result?.MPEsingle?.mpeStandard?.pretty || result?.MPE?.single?.mpeStandard?.pretty || result?.ExtendedMPE?.mpeStandard?.pretty

    const x = {
        laserOperation: data?.laserOperation.toLowerCase(),
        sourceType: data?.sourceType,
        standard: selectedStandard,
        wavelength: `${inputs.wavelength.num} ${inputs.wavelength.unit !== false ? inputs.wavelength.unit : " "}m`,

        ...(inputs.time) ? {
            time: `${inputs?.time?.num}${inputs.time.unit && inputs?.time?.unit !== false ? inputs?.time?.unit : " "}s`,
        } : {},
        ...(inputs.duration) ?
        {
            pulseDuration: `${inputs?.duration?.num} ${inputs?.duration?.unit !== false ? inputs?.duration?.unit : " "}s`
        }
        :
        {
            pulseDuration: `${inputs?.pulseDuration?.num} ${inputs?.pulseDuration?.unit !== false ? inputs?.pulseDuration?.unit : " "}s`
        },

        ...(inputs.power ? {
            power: `${inputs.power.num} ${inputs.power.unit !== false ? inputs.power.unit : " "}W`
        } 
        : inputs.peakPower ? {
            peakPower: `${inputs.peakPower.num} ${inputs.peakPower.unit !== false ? inputs.peakPower.unit : " "}W`
        }
        : inputs.averagePower ? {
            averagePower: `${inputs.averagePower.num} ${inputs.averagePower.unit !== false ? inputs.averagePower.unit : " "}W`
        } : {
            energy: `${inputs.energy.num} ${inputs.energy.unit !== false ? inputs.energy.unit : " "}J`
        }),

        ...(data.extendedSettings ? {
            apparentSourceSize: `${data.extendedSettings?.apparentSourceSize?.num} ${data.extendedSettings?.apparentSourceSize?.unit !== false ? data.extendedSettings?.apparentSourceSize?.unit : " "}m`
        } : inputs?.diameter ? 
        {
            diameter: `${inputs?.diameter?.num} ${inputs?.diameter?.unit !== false ? inputs?.diameter?.unit : " "}m`
        } : inputs?.numerical_aperture ? 
        {
            numerical_aperture: `${inputs?.numerical_aperture?.num} ${inputs?.numerical_aperture?.unit && inputs?.numerical_aperture?.unit !== false ? inputs?.numerical_aperture?.unit : " "}`
        } 
        :
        {
            beamDiameter: `${inputs?.beamDiameter?.num} ${inputs?.beamDiameter?.unit !== false && inputs?.beamDiameter?.unit ? inputs?.beamDiameter?.unit : " "}m`,

        }),
        ...(inputs.IGF && {
            IGF: inputs.IGF.num
        }),

        ...(inputs?.pulseFrequency && {
            pulseFrequency: `${inputs?.pulseFrequency?.num} ${inputs?.pulseFrequency?.unit !== false ? inputs?.pulseFrequency?.unit : " "}Hz`
        }),

        ...(inputs.beamDivergence ? {
            beamDivergence: `${inputs?.beamDivergence?.num} ${inputs?.beamDivergence?.unit !== false ? inputs?.beamDivergence?.unit : " "}m`,
        }: {
            beamDivergence: (result?.beamDivergence?.degrees?.pretty ?? result?.beamDivergence).includes('°') ? (result?.beamDivergence?.degrees?.pretty ?? result?.beamDivergence) : (result?.beamDivergence?.degrees?.pretty ?? result?.beamDivergence) + '°',
        }),

        distance: `${inputs.distance.num} ${inputs.distance.unit !== false ? inputs.distance.unit : " "}m`,

        spot_size: result?.outputBeamDiameter?.outputBeamDiameterPretty || result?.spotsize?.eng + 'm' || result.spotsize.d63.eng + 'm',
        eye_LA: result.limitingAperture.eye + 'mm',
        skin_LA: result.limitingAperture.skin + 'mm',
        applicable_eye: result?.applicableBeamArea?.applicableBeamAreaPrettiest || result.applicableBeamArea?.applicableBeamAreaEyePrettiest,
        applicable_skin: result?.skinApplicableArea?.skinApplicableAreaPrettiest || result.applicableBeamArea?.applicableBeamAreaSkinPrettiest,
        timebase: result.laserClass.condition1.timeBase,


        mpe: {
            eye: {
                ...(result.laserOperation.includes('repetitivelyPulsed')
                    ? {
                        mpe: {
                            single: {
                                mpe: result?.MPE?.single?.mpeStandard?.pretty,
                                excess: result?.MPEexcess?.joulesPretty_single?.pretty || result.safetyratio.joulesPretty.pretty,
                                ae_applicable: result?.MPE?.single?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty?.eng ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty?.eng ?? result?.AE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.MPE?.single?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.actual_joulesPerSqmPretty?.eng ?? result?.AE?.actual_joulesPerSqmPretty, "J") : getAE(result?.AE?.actual_wattsPerSqmPretty?.eng ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                            },
                            pulse_train: {
                                mpe: result?.MPE?.pulseTrain?.mpeStandard?.pretty,
                                excess: result?.MPEexcess?.joulesPretty_train?.pretty || result.safetyratio.averagePretty.pretty,
                                ae_applicable: result?.MPE?.pulseTrain?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty?.eng ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty?.eng ?? result?.AE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.MPE?.pulseTrain?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.actual_joulesPerSqmPretty?.eng ?? result?.AE?.actual_joulesPerSqmPretty, "J") : getAE(result?.AE?.actual_wattsPerSqmPretty?.eng ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                            },
                            average: {
                                mpe: result?.MPE?.average?.mpeStandard?.pretty,
                                excess: result?.MPEexcess?.joulesPretty_average?.pretty || result.safetyratio.pulseTrainPretty.pretty,
                                ae_applicable: result?.MPE?.average?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty?.eng ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty?.eng ?? result?.AE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.MPE?.average?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.actual_joulesPerSqmPretty?.eng ?? result?.AE?.actual_joulesPerSqmPretty, "J") : getAE(result?.AE?.actual_wattsPerSqmPretty?.eng ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                            }
                        },
                        ae_applicable: MPE?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty?.eng ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty?.eng ?? result?.AE?.wattsPerSqmPretty, "W"),
                        ae_actual: MPE?.includes("J") ? getAE(result?.AE?.actual_joulesPerSqmPretty?.eng ?? result?.AE?.actual_joulesPerSqmPretty, "J") : getAE(result?.AE?.actual_wattsPerSqmPretty?.eng ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                        excess: result?.MPEexcess?.joulesPretty?.pretty || result?.safetyratio?.joulesPretty?.pretty,
                        mostRestrictive: getMostRestrictiveKey("eye", result),
                    }
                    : {
                        mpe: MPE || 1,
                        ae_applicable: MPE?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty?.eng ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty?.eng ?? result?.AE?.wattsPerSqmPretty, "W"),
                        ae_actual: MPE?.includes("J") ? getAE(result?.AE?.actual_joulesPerSqmPretty?.eng ?? result?.AE?.actual_joulesPerSqmPretty, "J") : getAE(result?.AE?.actual_wattsPerSqmPretty?.eng ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                        excess: result?.MPEexcess?.joulesPretty?.pretty || result?.MPEexcess?.joulesPerSqmPretty || result?.safetyRatio?.pretty?.pretty || result?.safetyratio?.pretty?.pretty

                    }
                )
            },
            skin: {
                ...(result.laserOperation.includes('repetitivelyPulsed')
                    ? {
                        mpe: {
                            single: {
                                mpe: result?.skinMPE?.single?.mpeStandard?.pretty ?? result?.MPEskin?.mpeStandard?.pretty,
                                excess: result?.skinMPEExcess.joulesPretty_single.pretty,
                                ae_applicable: result?.skinMPE?.single?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.skinMPE?.single?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.actual_joulesPerSqmPretty?.eng ?? result?.skinAE?.actual_joulesPerSqmPretty, "J") : getAE(result?.skinAE?.actual_wattsPerSqmPretty?.eng ?? result?.skinAE?.actual_wattsPerSqmPretty, "W"),
                            },
                            pulse_train: {
                                mpe: result?.skinMPE?.PulseTrain?.mpeStandard?.pretty,
                                excess: result?.skinMPEExcess.joulesPretty_train.pretty,
                                ae_applicable: result?.skinMPE?.PulseTrain?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.skinMPE?.PulseTrain?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.actual_joulesPerSqmPretty?.eng ?? result?.skinAE?.actual_joulesPerSqmPretty, "J") : getAE(result?.skinAE?.actual_wattsPerSqmPretty?.eng ?? result?.skinAE?.actual_wattsPerSqmPretty, "W"),
                            },
                            average: {
                                mpe: result?.skinMPE?.MPEAverage?.mpeStandard?.pretty,
                                excess: result?.skinMPEExcess.joulesPretty_average.pretty,
                                ae_applicable: result?.skinMPE?.MPEAverage?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.skinMPE?.MPEAverage?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.actual_joulesPerSqmPretty?.eng ?? result?.skinAE?.actual_joulesPerSqmPretty, "J") : getAE(result?.skinAE?.actual_wattsPerSqmPretty?.eng ?? result?.skinAE?.actual_wattsPerSqmPretty, "W"),
                            }
                        },
                        ae_applicable: MPE?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                        ae_actual: MPE?.includes("J") ? getAE(result?.skinAE?.actual_joulesPerSqmPretty?.eng ?? result?.skinAE?.actual_joulesPerSqmPretty, "J") : getAE(result?.skinAE?.actual_wattsPerSqmPretty?.eng ?? result?.skinAE?.actual_wattsPerSqmPretty, "W"),
                        excess: result?.skinMPEExcess.joulesPretty.pretty,
                        mostRestrictive: getMostRestrictiveKey("skin", result),
                    }
                    : {
                        mpe: result?.skinMPE?.mpeStandard?.pretty ?? result?.MPEskin?.mpeStandard?.pretty,
                        ae_applicable: result?.skinMPE?.mpeStandard?.unit.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                        ae_actual: result?.skinMPE?.mpeStandard?.unit.includes("J") ? getAE(result?.skinAE?.actual_joulesPerSqmPretty?.eng ?? result?.skinAE?.actual_joulesPerSqmPretty, "J") : getAE(result?.skinAE?.actual_wattsPerSqmPretty?.eng ?? result?.skinAE?.actual_wattsPerSqmPretty, "W"),
                        excess: result?.skinMPEExcess?.joulesPretty?.pretty || result?.skinMPEExcess?.joulesPerSqmPretty
                    }
                )
            }
        },

        nohd: (result?.NOHD?.eng ?? result?.NOHD ?? result?.nohd.eng)?.includes("m") ? result?.NOHD?.eng || result?.NOHD || result?.nohd.eng : `${result?.NOHD?.eng || result?.NOHD || result?.nohd.eng}m`,
        enohd: (() => {
            const val =
                result?.ENOHD?.pretty ??
                result?.ENOHD ??
                result?.XNOHD?.pretty ??
                result?.xnohd?.pretty;
            return val ? (val.includes("m") ? val : `${val}m`) : 'N/A';
        })(),
        ael: {
            condition1: {
                classes: [
                    {
                        name: 'Class 1',
                        ael: result.laserClass.condition1.AEL_standard.single.c1.aelStandard?.pretty || 'N/A',
                        pf: result.laserClass.condition1.collectedEmissionJoules.joules <= result.laserClass.condition1.AEL_standard.single.c1.joules ? 'Pass' : 'Fail',
                        excess: result.laserClass.condition1.AEL_standard.Excess.c1excess?.pretty || 'N/A',
                        ...(result.laserOperation.includes('epetitively')) && {
                            ael_spTrain: result.laserClass.condition1.AEL_standard.pulseTrain.c1?.pretty || 'N/A',
                            ael_SPT: result.laserClass.condition1.AEL_standard.AELSPT.c1?.pretty || 'N/A',
                            ael_T: result.laserClass.condition1.AEL_standard.Average.c1.standard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition1.AEL_standard, "c1", result.laserClass.condition1.collectedEmissionJoules.joules)
                        }
                    },
                    {
                        name: 'Class 2',
                        ael: result.laserClass.condition1?.AEL_standard?.single?.c2?.aelStandard?.pretty || 'N/A',
                        pf: result.laserClass.condition1.collectedEmissionJoules.joules <= result.laserClass.condition1.AEL_standard.single.c2.joules ? 'Pass' : 'Fail',
                        excess: result.laserClass.condition1?.AEL_standard?.Excess?.c2excess?.pretty || 'N/A',
                        ...(result.laserOperation.includes('epetitively')) && {
                            ael_spTrain: result.laserClass.condition1.AEL_standard?.pulseTrain?.c2?.pretty || 'N/A',
                            ael_SPT: result.laserClass.condition1.AEL_standard?.AELSPT?.c2?.pretty || 'N/A',
                            ael_T: result.laserClass.condition1.AEL_standard?.Average?.c2?.standard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition1.AEL_standard, "c2", result.laserClass.condition1.collectedEmissionJoules.joules)
                        }
                    },
                    {
                        name: 'Class 3R',
                        ael: result.laserClass.condition1.AEL_standard.single.c3r.aelStandard?.pretty || 'N/A',
                        pf: result.laserClass.condition1.collectedEmissionJoules.joules <= result.laserClass.condition1.AEL_standard.single.c3r.joules ? 'Pass' : 'Fail',
                        excess: result.laserClass.condition1.AEL_standard.Excess.c3rexcess?.pretty || 'N/A',
                        ...(result.laserOperation.includes('epetitively')) && {
                            ael_spTrain: result.laserClass.condition1.AEL_standard.pulseTrain.c3r?.pretty || 'N/A',
                            ael_SPT: result.laserClass.condition1.AEL_standard.AELSPT.c3r?.pretty || 'N/A',
                            ael_T: result.laserClass.condition1.AEL_standard.Average.c3r.standard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition1.AEL_standard, "c3r", result.laserClass.condition1.collectedEmissionJoules.joules)
                        }
                    },
                    {
                        name: 'Class 3B',
                        ael: result.laserClass.condition1.AEL_standard.single.c3b.aelStandard?.pretty || 'N/A',
                        pf: result.laserClass.condition1.collectedEmissionJoules.joules <= result.laserClass.condition1.AEL_standard.single.c3b.joules ? 'Pass' : 'Fail',
                        excess: result.laserClass.condition1.AEL_standard.Excess.c3bexcess?.pretty || 'N/A',
                        ...(result.laserOperation.includes('epetitively')) && {
                            ael_spTrain: result.laserClass.condition1.AEL_standard.pulseTrain.c3b?.pretty || 'N/A',
                            ael_SPT: result.laserClass.condition1.AEL_standard.AELSPT.c3b?.pretty || 'N/A',
                            ael_T: result.laserClass.condition1.AEL_standard.Average.c3b.standard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition1.AEL_standard, "c3b", result.laserClass.condition1.collectedEmissionJoules.joules)
                        }
                    },
                    {
                        name: 'Collected Emission',
                        ael: `${result.laserClass.condition1.collectedEmissionJoules.joulesPretty} | ${result.laserClass.condition1.collectedEmissionWatts.wattsPretty}`
                    }
                ],
                misc: [
                    {
                        name: 'Aperture Stop',
                        value: result.laserClass.condition1.apertureStop
                    },
                    {
                        name: 'Aperture Distance',
                        value: result.laserClass.condition1.apertureDistance
                    },
                    {
                        name: 'Angular Subtense',
                        value: result.laserClass.condition1.angularSubtense || 'N/A'
                    },
                    {
                        name: 'Acceptance Angle',
                        value: result.laserClass.condition1.acceptanceAngle || 'N/A'
                    }
                ]
            },
            ...(result.laserOperation.includes('FO') && {
                condition2: {
                    classes: [
                        {
                            name: 'Class 1',
                            ael: result.laserClass.condition2.AEL_standard.single.c1.aelStandard?.pretty || 'N/A',
                            pf: result.laserClass.condition2.collectedEmissionJoules.joules <= result.laserClass.condition2.AEL_standard.single.c1.joules ? 'Pass' : 'Fail',
                            excess: result.laserClass.condition2.AEL_standard.Excess.c1excess?.pretty || 'N/A',
                            ...(result.laserOperation.includes('epetitively')) && {
                                ael_spTrain: result.laserClass.condition2.AEL_standard.pulseTrain.c1?.pretty || 'N/A',
                                ael_SPT: result.laserClass.condition2.AEL_standard.AELSPT.c1?.pretty || 'N/A',
                                ael_T: result.laserClass.condition2.AEL_standard.Average.c1.standard?.pretty || 'N/A',
                                mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition2.AEL_standard, "c1", result.laserClass.condition2.collectedEmissionJoules.joules)
                            }
                        },
                        {
                            name: 'Class 2',
                            ael: result.laserClass.condition2?.AEL_standard?.single?.c2?.aelStandard?.pretty || 'N/A',
                            pf: result.laserClass.condition2.collectedEmissionJoules.joules <= result.laserClass.condition2.AEL_standard.single.c2.joules ? 'Pass' : 'Fail',
                            excess: result.laserClass.condition2?.AEL_standard?.Excess?.c2excess?.pretty || 'N/A',
                            ...(result.laserOperation.includes('epetitively')) && {
                                ael_spTrain: result.laserClass.condition2.AEL_standard?.pulseTrain?.c2?.pretty || 'N/A',
                                ael_SPT: result.laserClass.condition2.AEL_standard?.AELSPT?.c2?.pretty || 'N/A',
                                ael_T: result.laserClass.condition2.AEL_standard?.Average?.c2?.standard?.pretty || 'N/A',
                                mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition2.AEL_standard, "c2", result.laserClass.condition2.collectedEmissionJoules.joules)
                            }
                        },
                        {
                            name: 'Class 3R',
                            ael: result.laserClass.condition2.AEL_standard.single.c3r.aelStandard?.pretty || 'N/A',
                            pf: result.laserClass.condition2.collectedEmissionJoules.joules <= result.laserClass.condition2.AEL_standard.single.c3r.joules ? 'Pass' : 'Fail',
                            excess: result.laserClass.condition2.AEL_standard.Excess.c3rexcess?.pretty || 'N/A',
                            ...(result.laserOperation.includes('epetitively')) && {
                                ael_spTrain: result.laserClass.condition2.AEL_standard.pulseTrain.c3r?.pretty || 'N/A',
                                ael_SPT: result.laserClass.condition2.AEL_standard.AELSPT.c3r?.pretty || 'N/A',
                                ael_T: result.laserClass.condition2.AEL_standard.Average.c3r.standard?.pretty || 'N/A',
                                mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition2.AEL_standard, "c3r", result.laserClass.condition2.collectedEmissionJoules.joules)
                            }
                        },
                        {
                            name: 'Class 3B',
                            ael: result.laserClass.condition2.AEL_standard.single.c3b.aelStandard?.pretty || 'N/A',
                            pf:  result.laserClass.condition2.collectedEmissionJoules.joules <= result.laserClass.condition2.AEL_standard.single.c3b.joules ? 'Pass' : 'Fail',
                            excess: result.laserClass.condition2.AEL_standard.Excess.c3bexcess?.pretty || 'N/A',
                            ...(result.laserOperation.includes('epetitively')) && {
                                ael_spTrain: result.laserClass.condition2.AEL_standard.pulseTrain.c3b?.pretty || 'N/A',
                                ael_SPT: result.laserClass.condition2.AEL_standard.AELSPT.c3b?.pretty || 'N/A',
                                ael_T: result.laserClass.condition2.AEL_standard.Average.c3b.standard?.pretty || 'N/A',
                                mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition2.AEL_standard, "c3b", result.laserClass.condition2.collectedEmissionJoules.joules)
                            }
                        },
                        {
                            name: 'Collected Emission',
                            ael: `${result.laserClass.condition2.collectedEmissionJoules.joulesPretty} | ${result.laserClass.condition2.collectedEmissionWatts.wattsPretty}`
                        }
                    ],
                    misc: [
                        {
                            name: 'Aperture Stop',
                            value: result.laserClass.condition2.apertureStop
                        },
                        {
                            name: 'Aperture Distance',
                            value: result.laserClass.condition2.apertureDistance
                        },
                        {
                            name: 'Angular Subtense',
                            value: result.laserClass.condition2.angularSubtense || 'N/A'
                        },
                        {
                            name: 'Acceptance Angle',
                            value: result.laserClass.condition2.acceptanceAngle || 'N/A'
                        }
                    ]
                },
            }),
            condition3: {
                classes: [
                    {
                        name: 'Class 1',
                        ael: result.laserClass.condition3.AEL_standard.single.c1.aelStandard?.pretty || 'N/A',
                        pf: result.laserClass.condition3.collectedEmissionJoules.joules <= result.laserClass.condition3.AEL_standard.single.c1.joules ? 'Pass' : 'Fail',
                        excess: result.laserClass.condition3.AEL_standard.Excess.c1excess?.pretty || 'N/A',
                        ...(result.laserOperation.includes('epetitively')) && {
                            ael_spTrain: result.laserClass.condition3.AEL_standard.pulseTrain.c1?.pretty || 'N/A',
                            ael_SPT: result.laserClass.condition3.AEL_standard.AELSPT.c1?.pretty || 'N/A',
                            ael_T: result.laserClass.condition3.AEL_standard.Average.c1.standard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition3.AEL_standard, "c1", result.laserClass.condition3.collectedEmissionJoules.joules)
                        }
                    },
                    {
                        name: 'Class 2',
                        ael: result.laserClass.condition3.AEL_standard?.single.c2.aelStandard?.pretty || 'N/A',
                        pf: result.laserClass.condition3.collectedEmissionJoules.joules <= result.laserClass.condition3.AEL_standard.single.c2.joules ? 'Pass' : 'Fail',
                        excess: result.laserClass.condition3.AEL_standard.Excess.c2excess?.pretty || 'N/A',
                        ...(result.laserOperation.includes('epetitively')) && {
                            ael_spTrain: result.laserClass.condition3?.AEL_standard?.pulseTrain?.c2?.pretty || 'N/A',
                            ael_SPT: result.laserClass.condition3.AEL_standard?.AELSPT?.c2?.pretty || 'N/A',
                            ael_T: result.laserClass.condition3.AEL_standard?.Average?.c2?.standard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition3.AEL_standard, "c2", result.laserClass.condition3.collectedEmissionJoules.joules)
                        }
                    },
                    {
                        name: 'Class 3R',
                        ael: result.laserClass.condition3.AEL_standard.single.c3r.aelStandard?.pretty || 'N/A',
                        pf: result.laserClass.condition3.collectedEmissionJoules.joules <= result.laserClass.condition3.AEL_standard.single.c3r.joules ? 'Pass' : 'Fail',
                        excess: result.laserClass.condition3.AEL_standard.Excess.c3rexcess?.pretty || 'N/A',
                        ...(result.laserOperation.includes('epetitively')) && {
                            ael_spTrain: result.laserClass.condition3.AEL_standard.pulseTrain.c3r?.pretty || 'N/A',
                            ael_SPT: result.laserClass.condition3.AEL_standard.AELSPT.c3r?.pretty || 'N/A',
                            ael_T: result.laserClass.condition3.AEL_standard.Average.c3r.standard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition3.AEL_standard, "c3r", result.laserClass.condition3.collectedEmissionJoules.joules)
                        }
                    },
                    {
                        name: 'Class 3B',
                        ael: result.laserClass.condition3.AEL_standard.single.c3b.aelStandard?.pretty || 'N/A',
                        pf: result.laserClass.condition3.collectedEmissionJoules.joules <= result.laserClass.condition3.AEL_standard.single.c3b.joules ? 'Pass' : 'Fail',
                        excess: result.laserClass.condition3.AEL_standard.Excess.c3bexcess?.pretty || 'N/A',
                        ...(result.laserOperation.includes('epetitively')) && {
                            ael_spTrain: result.laserClass.condition3.AEL_standard.pulseTrain?.c3b?.pretty || 'N/A',
                            ael_SPT: result.laserClass.condition3.AEL_standard.AELSPT.c3b?.pretty || 'N/A',
                            ael_T: result.laserClass.condition3.AEL_standard.Average.c3b?.standard?.pretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition3.AEL_standard, "c3b", result.laserClass.condition3.collectedEmissionJoules.joules)
                        }
                    },
                    {
                        name: 'Collected Emission',
                        ael: `${result.laserClass.condition3.collectedEmissionJoules.joulesPretty} | ${result.laserClass.condition3.collectedEmissionWatts.wattsPretty}`
                    }
                ],
                misc: [
                    {
                        name: 'Aperture Stop',
                        value: result.laserClass.condition3.apertureStop
                    },
                    {
                        name: 'Aperture Distance',
                        value: result.laserClass.condition3.apertureDistance
                    },
                    {
                        name: 'Angular Subtense',
                        value: result.laserClass.condition3.angularSubtense || 'N/A'
                    },
                    {
                        name: 'Acceptance Angle',
                        value: result.laserClass.condition3.acceptanceAngle || 'N/A'
                    }
                ]
            }
        },

        eyewear: [
            {
                config: 'Results at 200m',
                nominal_od: result.NominalOD.OD,
                rb_number: result.RBNumber,
                lb_glass: result.Glass,
                lb_plastic: result.Plastic,
                lb_glass_average: result.Glass_average,
                lb_plastic_average: result.Plastic_average,

            },
            {
                config: 'Results at 0.1m',
                nominal_od: result.NominalOD_distance.OD,
                rb_number: result.RBNumber_distance,
                lb_glass: result.Glass_Distance,
                lb_plastic: result.Plastic_Distance,
                lb_glass_average: result.GlassAverage_Distance,
                lb_plastic_average: result.PlasticAverage_Distance
                ,
            }
        ],

        verdict: result.laserClass.Class,

        correctionFactors: result.correctionFactors,
        spectrum: result.spectrum
    }

    return x
}

function getMostRestrictiveKey(type, result) {
    const source =
        type === 'eye'
            ? result?.MPE
            : result?.skinMPE;

    if (!source) return null;

    const values = {
        single: source?.single?.mpeStandard?.num,
        pulse_train: source?.pulseTrain?.mpeStandard?.num || source?.PulseTrain?.mpeStandard?.num,
        average: source?.average?.mpeStandard?.num || source?.MPEAverage?.mpeStandard?.num
    };

    // Filter out undefined/null before finding min
    const filtered = Object.entries(values).filter(([_, v]) => v != null);

    if (filtered.length === 0) return null;

    const minVal = Math.min(...filtered.map(([_, v]) => v));

    // Return the key with the smallest value
    const mostRestrictive = filtered.find(([_, v]) => v === minVal)?.[0];
    return mostRestrictive || null;
}

function getMostRestrictiveAEL({ single, pulseTrain, AELSPT, }, cls, collectedEmission) {
    const values = {
        ael: single[cls].aelStandard?.num,
        ael_spTrain: pulseTrain[cls].raw,
        ael_SPT: AELSPT[cls].raw,

    };

    // Filter out invalid (NaN) values
    const filtered = Object.entries(values).filter(([_, v]) => !isNaN(v));

    if (filtered.length === 0) return null;

    // Find smallest value
    const minVal = Math.min(...filtered.map(([_, v]) => v));



    // Get the key that matched the min
    const mostRestrictive = filtered.find(([_, v]) => v === minVal);


    const status = collectedEmission <= mostRestrictive[1] ? 'Pass' : 'Fail'

    return mostRestrictive
        ? { key: mostRestrictive[0], value: mostRestrictive[1], status: status }
        : null;
}

